<!--
 * @Author: tony.zhu
 * @Date: 2025-02-08 14:04:45
 * @LastEditTime: 2025-02-28 16:06:58
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="lang-switch">
    <el-select v-model="currentLang" @change="changeLang" size="small">
      <el-option
        v-for="item in languageOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import i18n from './index'

import { loadLanguageAsync } from "./index.js";
import { updateLang } from '@/api/app.js';

import {
  setCookie,
} from '@/base/cookie'

export default {
  data() {
    return {
      currentLang: this.$i18n.locale,
      languageOptions: [
        { label: "中文", value: "zh" },
        { label: "English", value: "en" },
        { label: "中文繁体", value: "tc" },
      ],
      copyLang: this.$i18n.locale,
    };
  },
  methods: {
    async changeLang(lang) {
      const langObj = {
        zh: 'zh-CN',
        en: 'en',
        tc: 'zh-TW'
      }
      const res = await updateLang({lang: langObj[lang]})
      if(res.code !== 200){
        this.$message.error(res.message ? res.message : i18n.t('language_languageswitch_2984'))
        return
      }
      //await loadLanguageAsync(lang);
      this.$confirm(i18n.t('language_languageswitch_2983'),i18n.t('view_public_topbar_23'), {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        type: 'warning',
        customClass: 'language_confirm_' + this.$store.state.app.web_language_wm
      }).then(()=>{
        this.currentLang = lang;
        setCookie('web_language_wm', lang);
        //this.$store.commit('app/SET_web_language_wm', lang)
        location.reload();
      }).catch(()=>{
        this.currentLang = this.copyLang;
      })

      this.$emit("reload");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/language/languageSwitch.vue